module.exports = __webpack_public_path__ + "static/metamorphosis-664e82ea7fd7174e9215807b8ea0bfab.png";